const palette = {
  light_aqua_green: '#C5EDE9',
  cyan: '#82E7DD',
  light_grayish_cyan: '#CCEBE8',
  dark_blue: '#0E303E',
  primary_blue: '#1890FF',
  vivid_blue: '#1A90FF',
  bright_blue: '#308FE8',
  cyan_blue: '#0063F8',
  light_blue: '#8ACCFF',
  soft_blue: '#957EFE',
  grey: '#EBEBEB',
  dark_gray: '#979797',
  grayish_white: '#F8F8F8',
  vivid_orange: '#FFA71E',
  white: '#FFFFFF',
  black: '#000000',
  gt_text_primary: '#262626',
  gt_text_secondary: '#8C8C8C',
  gt_text_danger: '#FF4D4F',
  gt_text_warning: '#FAAD14',
  gt_text_success: '#52C41A',
  gt_text_disabled: '#C8C8C8',
  gt_grey_light_2: '#FAFAFA',
  gt_grey_light_3: '#F5F5F5',
  gt_grey_light_5: '#D9D9D9',
  gt_grey_light_6: '#BFBFBF',
  gt_grey_dark_4: '#262626',
  gt_grey_1: '#E9F0F2',
  gt_teal_1: '#EEF5F7',
  gt_teal_2: '#CCE1E6',
  gt_teal_3: '#AACDD5',
  gt_teal_6: '#559BAB',
  gt_teal_8: '#2A4D55',
  gt_green_1: '#F4FFDA',
  gt_green_5: '#C9FF43',
  gt_green_6: '#B7FF05',
  gt_lemon_2: '#E7FBA8',
  gt_seafoam_6: '#20D2B5',
  gt_green_7: '#AAED05',
};

export default palette;
